import React from 'react'
import { SvgIcon } from '@mui/material'

export const LinkIcon = props => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <path
      d="M8 12a1 1 0 0 0 1 1h6a1 1 0 0 0 0-2H9a1 1 0 0 0-1 1Zm2 3H7a3 3 0 0 1 0-6h3a1 1 0 1 0 0-2H7a5 5 0 1 0 0 10h3a1 1 0 0 0 0-2Zm7-8h-3a1 1 0 1 0 0 2h3a3 3 0 0 1 0 6h-3a1 1 0 0 0 0 2h3a5 5 0 1 0 0-10Z"
      fill="inherit"
    />
  </SvgIcon>
)
